import THUMB_SLOTS from "./helpers/thumbSlots";
import ProviderTileThumb from "./ProviderTileThumb";

type Props = {
  games: ProviderTileGame[];
};

const ProviderTileGames: FC<Props> = ({ games }) => {
  if (!games.length) {
    return null;
  }

  return (
    <span
      data-slot="provider-tile-games"
      data-testid="provider-thumbs"
      className="absolute bottom-0 left-1/2 block aspect-[182.362/125.167] h-[61.06%] -translate-x-1/2"
    >
      {THUMB_SLOTS.map((slot) => {
        const game = games[slot.gameIndex];
        if (!game) {
          return null;
        }
        return (
          <ProviderTileThumb
            key={slot.name}
            thumbUrl={game.thumbUrl}
            geometry={slot.geometry}
            className={slot.className}
          />
        );
      })}
    </span>
  );
};

export default ProviderTileGames;
